import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { receiveAllCustomersInfo, receiveCustomersInfo } from '../customers_info/slice';
import { receiveInventory } from '../inventory/slice';
import { getOrganizationSlug } from '../organizations/selectors';
import { getLockers, getSiteLockers } from './data';
import { errorReceiveAllLockers, errorReceiveSiteLockers, failedReceiveAllLockers, failedReceiveSiteLockers, receiveAllLockers, receiveSiteLockers } from './slice';
export function* requestAllLockers(action) {
    try {
        const { consumerAPI } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getLockers, organization, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveAllLockers());
            }
            else if (data) {
                if (data.length < 1) {
                    throw new Error(t('NO_LOCKER_INFO_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveAllLockers(data));
                yield put(receiveAllCustomersInfo(consumerAPI));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveAllLockers());
            }
            else if (response && response.status === 200) {
                if (response.data.length < 1) {
                    throw new Error(t('NO_LOCKER_INFO_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveAllLockers(response.data));
                yield put(receiveAllCustomersInfo(consumerAPI));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveAllLockers());
    }
}
export function* requestSiteLockers(action) {
    try {
        const { consumerAPI, locationSlug } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getSiteLockers, organization, locationSlug, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveSiteLockers());
            }
            else if (data) {
                if (data.length < 1) {
                    throw new Error(t('NO_LOCKER_INFO_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveSiteLockers(data));
                yield put(receiveCustomersInfo(consumerAPI));
                yield put(receiveInventory());
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveSiteLockers());
            }
            else if (response && response.status === 200) {
                if (response.data.length < 1) {
                    throw new Error(t('NO_LOCKER_INFO_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveSiteLockers(response.data));
                yield put(receiveCustomersInfo(consumerAPI));
                yield put(receiveInventory());
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveSiteLockers());
    }
}
export function* watchRequestAllLockers() {
    yield takeLatest('lockers/requestAllLockers', requestAllLockers);
}
export function* watchRequestSiteLockers() {
    yield takeLatest('lockers/requestSiteLockers', requestSiteLockers);
}
